import instance from "./instance";
import mockData from "./mock.json";
import { mock } from "./index";
import * as utils from "../helpers/utils";

export const registeredProperty = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.RegisteredProperityResponce };
    default:
      return instance.post("/RegisteredProperty/CreateRequest", data);
  }
};
export const newRegisteredProperty = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.RegisteredProperityResponce };
    default:
      return instance.post("/NewRegisteredProperty/CreateRequest", data);
  }
};
export const newRegisteredPropertyWithPropertyPlanAndCoordinatesAndChangeStatement =
  async (data) => {
    switch (mock) {
      case true:
        return { status: 200, data: mockData.RegisteredProperityResponce };
      default:
        return instance.post(
          "/NewRegisteredPropertyWithPropertyPlanAndCoordinatesAndChangeStatement/CreateRequest",
          data
        );
    }
  };
export const newRegisteredPropertyWithPropertyPlanAndCoordinates = async (
  data
) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.RegisteredProperityResponce };
    default:
      return instance.post(
        "/NewRegisteredPropertyWithPropertyPlanAndCoordinates/CreateRequest",
        data
      );
  }
};
export const newRegisteredWithPropertyPlanAndChangeStatement = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.RegisteredProperityResponce };
    default:
      return instance.post(
        "/NewRegisteredWithPropertyPlanAndChangeStatement/CreateRequest",
        data
      );
  }
};
export const newRegisteredPropertyAuthorization = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.RegisteredProperityResponce };
    default:
      return instance.post(
        "/NewRegisteredPropertyAuthorization/CreateRequest",
        data
      );
  }
};
export const newPropertyPlanWithRegisteredReport = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.RegisteredProperityResponce };
    default:
      return instance.post(
        "/NewPropertyPlanWithRegisteredReport/CreateRequest",
        data
      );
  }
};
export const newPropertyPlanWithCoordinates = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.RegisteredProperityResponce };
    default:
      return instance.post(
        "/NewPropertyPlanWithCoordinates/CreateRequest",
        data
      );
  }
};
export const newPropertyPlanWithChangeStatement = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.RegisteredProperityResponce };
    default:
      return instance.post(
        "/NewPropertyPlanWithChangeStatement/CreateRequest",
        data
      );
  }
};
export const newPropertyPlanWithCoordinatesAndChangeStatement = async (
  data
) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.RegisteredProperityResponce };
    default:
      return instance.post(
        "/NewPropertyPlanWithCoordinatesAndChangeStatement/CreateRequest",
        data
      );
  }
};

export const checkCanGenerateRegisteredProperty = async (regNo, isFlat, dept_Code) => {
  switch (mock) {
    case true:
      return { status: 200, data: true };
    default:
      return instance.get(
        `/NewRegisteredProperty/CheckCanGenerateRegisteredProperty?regNo=${utils.prepareParam(
          regNo
        )}&isFlat=${isFlat}&dept_Code=${dept_Code}`
      );
  }
};

export const getCoordinates = async (DLS_KEY) => {
  switch (mock) {
    case true:
      return { status: 200, data: {} };
    default:
      return instance.post(`/Land/GetCoordinates?DLS_KEY=${DLS_KEY}`);
  }
};

export const disclosureProperty = async () => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.DisclosurePropertyResponce };
    default:
      return instance.post("/PropertyDisclosure/CreateRequest");
  }
};
export const newDisclosureProperty = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.DisclosurePropertyResponce };
    default:
      return instance.post("/NewPropertyDisclosure/CreateRequest", data);
  }
};

export const myRequests = async () => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getQuickervices };
    default:
      return instance.get("/QuickServicesMyRequests/Index");
  }
};

export const newMyRequests = async (pageNumber, requestNumber, efCode) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.newGetQuickervices };
    default:
      return instance.get(
        `/NewQuickServicesMyRequests/GetMyQuickServiceRequests`, {
        params: {
          pageNumber,
          requestNumber,
          efCode
        }
      }
      );
  }
};

export const propertyPlanReport = async (data) => {
  return instance.post("/PropertyPlanReport/CreateRequest", data);
};

export const newPropertyPlanReport = async (data) => {
  return instance.post("/NewPropertyPlanReport/CreateRequest", data);
};

export const newCoordinates = async (data) => {
  return instance.post("/NewCoordinates/CreateRequest", data);
};

export const changeStatement = async (data) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.changeStatement };
    default:
      return instance.post("/ChangeStatement/CreateRequest", data);
  }
};

export const propertyOwnerShip = async () => {
  return instance.post("/PropertyOwnership/CreateRequest");
};
export const newPropertyOwnerShip = async (data) => {
  return instance.post("/NewPropertyOwnership/CreateRequest", data);
};
export const registeredPropertyAuthorization = async () => {
  return instance.post("RegisteredPropertyAuthorization/CreateRequest");
};

export const completeRequestForRegisteredPropertyAuthorization = async (
  data
) => {
  return instance.post(
    "/RegisteredPropertyAuthorization/CompleteRequestForApproval",
    data
  );
};
export const createChangeStatement = async () => {
  return instance.post("/ChangeStatement/CreateRequest");
};
export const createNewChangeStatement = async (data) => {
  return instance.post("/NewChangeStatement/CreateRequest", data);
};

export const validateChangeStatementExist = async (data) => {
  return instance.get("/NewChangeStatement/ValidateChangeStatementExist", {
    params: {
      VILL_CODE: data.VILL_CODE,
      HOD_CODE: data.HOD_CODE,
      SECT_CODE: data.SECT_CODE,
      SHEET_NO: data.SHEET_NO,
      PARCL_NO: data.PARCL_NO,
    },
  });
};

export const completeRequestForApproval = async (data) => {
  return instance.post("/ChangeStatement/CompleteRequestForApproval", data);
};

export const printNewQuickServicesMyRequests = async (requestId, regNo) => {
  const params = { requestId, regNo };
  return instance.get("/NewQuickServicesMyRequests/Print", { params });
};

export const printRegisteredProperty = async (refId, regNo) => {
  return instance.get(
    `/RegisteredProperty/Print?refId=${refId}&regNo=${utils.prepareParam(
      regNo
    )}`
  );
};

export const printPropertyDisclosure = async (refId) => {
  return instance.get(`/PropertyDisclosure/Print?refId=${refId}`);
};
export const printNewPropertyDisclosure = async (refId) => {
  return instance.get(`/NewPropertyDisclosure/Print?requestId=${refId}`);
};

export const printPropertyOwnerShip = async (refId) => {
  return instance.get(`/PropertyOwnership/Print?refId=${refId}`);
};
export const printNewPropertyOwnerShip = async (refId) => {
  return instance.get(`/NewPropertyOwnership/Print?requestId=${refId}`);
};

export const printPropertyPlanReport = async (RequestID, regNo) => {
  return instance.get(
    `/PropertyPlanReport/Print?RequestID=${RequestID}&regNo=${utils.prepareParam(
      regNo
    )}`
  );
};
export const printNewPropertyPlanReport = async (RequestID, regNo) => {
  return instance.get(
    `/NewPropertyPlanReport/Print?requestId=${RequestID}&regNo=${utils.prepareParam(
      regNo
    )}`
  );
};

export const printRegisteredPropertyAuthorization = async (refrenceNumber) => {
  return instance.get(
    `/RegisteredPropertyAuthorization/Print?refId=${refrenceNumber}`
  );
};

export const printChangeStatement = async (refrenceNumber) => {
  return instance.get(`/ChangeStatement/Print?refId=${refrenceNumber}`);
};

export const getMyQSProperties = async () => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getMyPropertyWithPagination.lstResult };
    default:
      return instance.get("/Land/GetMyPropertiesQS");
  }
};
export const getMyPropertiesQSTotalCount = async (parcNo = "") => {
  return instance.get(`/Land/GetMyPropertiesQSTotalCount?parcNo=${parcNo}`);
};
export const getMyPropertiesQSWithPaging = async (page, parcNo = "") => {
  return instance.get(
    `/Land/GetMyPropertiesQSWithPaging?pageIndex=${page}&parcNo=${parcNo}`
  );
};
export const getMyPropertiesWithoutRgVo = async () => {
  return instance.get(`/Land/GetMyPropertiesWithoutRgVo`);
};
export const getMyPropertiesWithoutRgVoWithPaging = async (
  pageNumber,
  parcNo
) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getMyPropertyWithPagination };
    default:
      return instance.get(`/Land/GetMyPropertiesWithoutRgVoWithPaging`, {
        params: { pageNumber, parcNo },
      });
  }
};

export const getQuickServiceFees = async (serviceId) => {
  console.log("serviceId", serviceId);

  switch (mock) {
    case true:
      if (serviceId == "163") {
        return { status: 200, data: 123 };
      } else if (serviceId == "161") {
        return { status: 200, data: 22 };
      } else if (serviceId == "162") {
        return { status: 200, data: 33 };
      }
      return { status: 200, data: 123 };
    default:
      return instance
        .get(
          `/NewQuickServicesMyRequests/GetQuickServiceFees?serviceId=${serviceId}`
        )
        .then((res) => {
          return { status: 200, data: res.data.totaL_FEES };
          // return {
          //   status: 200,
          //   data: {
          //     servicE_ID: 163,
          //     servicE_DESC: "صورة اخراج قيد",
          //     totaL_FEES: 3,
          //   },
          // };
        });
  }
};

export const getMyPropertiesWithPaging = async (
  pageNumber,
  parcNo
) => {
  switch (mock) {
    case true:
      return { status: 200, data: mockData.getMyPropertyWithPagination };
    default:
      return instance.get(`/Land/GetMyPropertiesWithPaging`, {
        params: { pageNumber, parcNo },
      });
  }
};
